import React from 'react';
import PropTypes from "prop-types";
export var DefaultItemActionProps = function DefaultItemActionProps() {
  return /*#__PURE__*/React.createElement("div", null);
};
DefaultItemActionProps.propTypes = {
  /**
     * The type of action
     */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button"]), PropTypes.oneOf(["icon"]).isRequired]),

  /**
     * Defines the color of the button
     */
  color: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.oneOf(["primary", "danger", "text", "ghost", "success", "warning"]).isRequired, PropTypes.func.isRequired]), PropTypes.oneOfType([PropTypes.oneOf(["accent", "danger", "ghost", "primary", "subdued", "success", "text", "warning"]).isRequired, PropTypes.func.isRequired])]),

  /**
     * The display name of the action (will be the button caption)
     */

  /**
     * The display name of the action (will be the button caption)
     */
  name: PropTypes.oneOfType([PropTypes.node.isRequired, PropTypes.func.isRequired]).isRequired,

  /**
     * Describes the action (will be the button title)
     */

  /**
     * Describes the action (will be the button title)
     */
  description: PropTypes.string.isRequired,

  /**
     * A handler function to execute the action
     */

  /**
     * A handler function to execute the action
     */
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,

  /**
     * A callback function that determines whether the action is available
     */

  /**
     * A callback function that determines whether the action is available
     */
  available: PropTypes.func,

  /**
     * A callback function that determines whether the action is enabled
     */

  /**
     * A callback function that determines whether the action is enabled
     */
  enabled: PropTypes.func,
  isPrimary: PropTypes.bool,
  "data-test-subj": PropTypes.string,

  /**
     * Associates an icon with the button
     */
  icon: PropTypes.oneOfType([PropTypes.oneOf(["accessibility", "addDataApp", "advancedSettingsApp", "aggregate", "alert", "analyzeEvent", "annotation", "apmApp", "apmTrace", "apps", "appSearchApp", "arrowDown", "arrowLeft", "arrowRight", "arrowUp", "asterisk", "auditbeatApp", "beaker", "bell", "bellSlash", "bolt", "boxesHorizontal", "boxesVertical", "branch", "broom", "brush", "bug", "bullseye", "calendar", "canvasApp", "codeApp", "check", "checkInCircleFilled", "cheer", "classificationJob", "clock", "cloudDrizzle", "cloudStormy", "cloudSunny", "compute", "console", "consoleApp", "controlsHorizontal", "controlsVertical", "copy", "copyClipboard", "createAdvancedJob", "createMultiMetricJob", "createPopulationJob", "createSingleMetricJob", "cross", "crossClusterReplicationApp", "crosshairs", "crossInACircleFilled", "currency", "cut", "dashboardApp", "database", "dataVisualizer", "devToolsApp", "discoverApp", "document", "documentEdit", "documents", "dot", "download", "editorAlignCenter", "editorAlignLeft", "editorAlignRight", "editorBold", "editorCodeBlock", "editorComment", "editorDistributeHorizontal", "editorDistributeVertical", "editorHeading", "editorItalic", "editorItemAlignLeft", "editorItemAlignBottom", "editorItemAlignCenter", "editorItemAlignMiddle", "editorItemAlignRight", "editorItemAlignTop", "editorLink", "editorOrderedList", "editorPositionBottomLeft", "editorPositionBottomRight", "editorPositionTopLeft", "editorPositionTopRight", "editorRedo", "editorStrike", "editorTable", "editorUnderline", "editorUndo", "editorUnorderedList", "email", "empty", "emsApp", "eql", "exit", "expand", "expandMini", "exportAction", "eye", "eyeClosed", "faceHappy", "faceNeutral", "faceSad", "filebeatApp", "filter", "flag", "fold", "folderCheck", "folderClosed", "folderExclamation", "folderOpen", "fullScreen", "gear", "gisApp", "glasses", "globe", "grab", "grabHorizontal", "graphApp", "grid", "grokApp", "heart", "heartbeatApp", "heatmap", "help", "home", "iInCircle", "image", "importAction", "indexClose", "indexEdit", "indexFlush", "indexManagementApp", "indexMapping", "indexOpen", "indexPatternApp", "indexRollupApp", "indexRuntime", "indexSettings", "inputOutput", "inspect", "invert", "ip", "keyboardShortcut", "kqlField", "kqlFunction", "kqlOperand", "kqlSelector", "kqlValue", "lensApp", "link", "list", "listAdd", "lock", "lockOpen", "logsApp", "logoAerospike", "logoApache", "logoAppSearch", "logoAWS", "logoAWSMono", "logoAzure", "logoAzureMono", "logoBeats", "logoBusinessAnalytics", "logoCeph", "logoCloud", "logoCloudEnterprise", "logoCode", "logoCodesandbox", "logoCouchbase", "logoDocker", "logoDropwizard", "logoElastic", "logoElasticsearch", "logoElasticStack", "logoEnterpriseSearch", "logoEtcd", "logoGCP", "logoGCPMono", "logoGithub", "logoGmail", "logoGolang", "logoGoogleG", "logoHAproxy", "logoIBM", "logoIBMMono", "logoKafka", "logoKibana", "logoKubernetes", "logoLogging", "logoLogstash", "logoMaps", "logoMemcached", "logoMetrics", "logoMongodb", "logoMySQL", "logoNginx", "logoObservability", "logoOsquery", "logoPhp", "logoPostgres", "logoPrometheus", "logoRabbitmq", "logoRedis", "logoSecurity", "logoSiteSearch", "logoSketch", "logoSlack", "logoUptime", "logoWebhook", "logoWindows", "logoWorkplaceSearch", "logstashFilter", "logstashIf", "logstashInput", "logstashOutput", "logstashQueue", "machineLearningApp", "magnet", "magnifyWithMinus", "magnifyWithPlus", "managementApp", "mapMarker", "memory", "menu", "menuDown", "menuLeft", "menuRight", "menuUp", "merge", "metricbeatApp", "metricsApp", "minimize", "minus", "minusInCircle", "minusInCircleFilled", "monitoringApp", "moon", "nested", "node", "notebookApp", "number", "offline", "online", "outlierDetectionJob", "package", "packetbeatApp", "pageSelect", "pagesSelect", "partial", "paperClip", "pause", "pencil", "pin", "pinFilled", "pipelineApp", "play", "plus", "plusInCircle", "plusInCircleFilled", "popout", "push", "questionInCircle", "quote", "recentlyViewedApp", "refresh", "regressionJob", "reporter", "reportingApp", "returnKey", "save", "savedObjectsApp", "scale", "search", "searchProfilerApp", "securityAnalyticsApp", "securityApp", "securitySignal", "securitySignalDetected", "securitySignalResolved", "shard", "share", "snowflake", "sortable", "sortDown", "sortLeft", "sortRight", "sortUp", "spacesApp", "sqlApp", "starEmpty", "starEmptySpace", "starFilled", "starFilledSpace", "starMinusEmpty", "starMinusFilled", "starPlusEmpty", "starPlusFilled", "stats", "stop", "stopFilled", "stopSlash", "storage", "string", "submodule", "swatchInput", "symlink", "tableOfContents", "tableDensityExpanded", "tableDensityCompact", "tableDensityNormal", "tag", "tear", "temperature", "timeline", "timelionApp", "training", "trash", "upgradeAssistantApp", "uptimeApp", "unfold", "unlink", "user", "users", "usersRolesApp", "vector", "videoPlayer", "visArea", "visAreaStacked", "visBarHorizontal", "visBarHorizontalStacked", "visBarVertical", "visBarVerticalStacked", "visGauge", "visGoal", "visLine", "visMapCoordinate", "visMapRegion", "visMetric", "visPie", "visTable", "visTagCloud", "visText", "visTimelion", "visualizeApp", "visVega", "visVisualBuilder", "watchesApp", "workplaceSearchApp", "wrench", "tokenClass", "tokenProperty", "tokenEnum", "tokenVariable", "tokenMethod", "tokenAnnotation", "tokenException", "tokenInterface", "tokenParameter", "tokenField", "tokenElement", "tokenFunction", "tokenBoolean", "tokenString", "tokenArray", "tokenNumber", "tokenConstant", "tokenObject", "tokenEvent", "tokenKey", "tokenNull", "tokenStruct", "tokenPackage", "tokenOperator", "tokenEnumMember", "tokenRepo", "tokenSymbol", "tokenFile", "tokenModule", "tokenNamespace", "tokenDate", "tokenIP", "tokenNested", "tokenAlias", "tokenShape", "tokenGeo", "tokenRange", "tokenBinary", "tokenJoin", "tokenPercolator", "tokenFlattened", "tokenRankFeature", "tokenRankFeatures", "tokenKeyword", "tokenCompletionSuggester", "tokenDenseVector", "tokenText", "tokenTokenCount", "tokenSearchType", "tokenHistogram"]).isRequired, PropTypes.func.isRequired])
};
export var SearchProps = function SearchProps() {
  return /*#__PURE__*/React.createElement("div", null);
};
SearchProps.propTypes = [PropTypes.bool.isRequired, PropTypes.shape({
  onChange: PropTypes.func,

  /**
     The initial query the bar will hold when first mounted
     */
  defaultQuery: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),

  /**
     If you wish to use the search bar as a controlled component, continuously pass the query via this prop.
     */
  query: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.string.isRequired]),

  /**
     Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.
     */
  box: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    isInvalid: PropTypes.bool,
    fullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,

    /**
       * Called when the user presses [Enter] OR on change if the incremental prop is `true`.
       * If you don't need the on[Enter] functionality, prefer using onChange
       */
    onSearch: PropTypes.func,

    /**
       * When `true` the search will be executed (that is, the `onSearch` will be called) as the
       * user types.
       */
    incremental: PropTypes.bool,

    /**
       * when `true` creates a shorter height input
       */
    compressed: PropTypes.bool,
    inputRef: PropTypes.func,

    /**
       * Shows a button that quickly clears any input
       */
    isClearable: PropTypes.bool,

    /**
       * Creates an input group with element(s) coming before input
       * `string` | `ReactElement` or an array of these
       */
    prepend: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),

    /**
       * Creates an input group with element(s) coming after input.
       * `string` | `ReactElement` or an array of these
       */
    append: PropTypes.oneOfType([PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]).isRequired).isRequired]),
    className: PropTypes.string,
    "aria-label": PropTypes.string,
    "data-test-subj": PropTypes.string,
    // Boolean values are not meaningful to this EuiSearchBox, but are allowed so that other
    // components can use e.g. a true value to mean "auto-derive a schema". See EuiInMemoryTable.
    // Admittedly, this is a bit of a hack.
    schema: PropTypes.oneOfType([PropTypes.shape({
      strict: PropTypes.bool,
      fields: PropTypes.any,
      flags: PropTypes.arrayOf(PropTypes.string.isRequired)
    }).isRequired, PropTypes.bool.isRequired])
  }),

  /**
     An array of search filters. See #SearchFilterConfig.
     */
  filters: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    type: PropTypes.oneOf(["is"]).isRequired,
    field: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_selection"]).isRequired,
    field: PropTypes.string,
    name: PropTypes.string.isRequired,

    /**
       * See #FieldValueOptionType
       */
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
        type: PropTypes.oneOf(["date"]).isRequired,
        raw: PropTypes.any.isRequired,
        granularity: PropTypes.oneOfType([PropTypes.shape({
          es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
          js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
          isSame: PropTypes.func.isRequired,
          start: PropTypes.func.isRequired,
          startOfNext: PropTypes.func.isRequired,
          iso8601: PropTypes.func.isRequired
        }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
        text: PropTypes.string.isRequired,
        resolve: PropTypes.func.isRequired
      }).isRequired]).isRequired,
      name: PropTypes.string,
      view: PropTypes.node
    }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
    filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
    cache: PropTypes.number,
    multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
    loadingMessage: PropTypes.string,
    noOptionsMessage: PropTypes.string,
    searchThreshold: PropTypes.number,
    available: PropTypes.func,
    autoClose: PropTypes.bool,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    available: PropTypes.func,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
    field: PropTypes.string.isRequired,

    /**
       * See #FieldValueToggleGroupFilterItemType
       */
    items: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
      name: PropTypes.string.isRequired,
      negatedName: PropTypes.string,
      operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
    }).isRequired).isRequired,
    available: PropTypes.func
  }).isRequired]).isRequired),

  /**
     * Tools which go to the left of the search bar.
     */
  toolsLeft: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),

  /**
     * Tools which go to the right of the search bar.
     */
  toolsRight: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired]),

  /**
     * Date formatter to use when parsing date values
     */
  dateFormat: PropTypes.any,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
}).isRequired];
export var SearchFilterConfigProps = () => <div />;
SearchFilterConfigProps.propTypes = [PropTypes.shape({
  type: PropTypes.oneOf(["is"]).isRequired,
  field: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_selection"]).isRequired,
  field: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
      type: PropTypes.oneOf(["date"]).isRequired,
      raw: PropTypes.any.isRequired,
      granularity: PropTypes.oneOfType([PropTypes.shape({
        es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
        js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
        isSame: PropTypes.func.isRequired,
        start: PropTypes.func.isRequired,
        startOfNext: PropTypes.func.isRequired,
        iso8601: PropTypes.func.isRequired
      }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
      text: PropTypes.string.isRequired,
      resolve: PropTypes.func.isRequired
    }).isRequired]).isRequired,
    name: PropTypes.string,
    view: PropTypes.node
  }).isRequired).isRequired, PropTypes.func.isRequired]).isRequired,
  filterWith: PropTypes.oneOfType([PropTypes.oneOf(["prefix", "includes"]), PropTypes.func.isRequired]),
  cache: PropTypes.number,
  multiSelect: PropTypes.oneOfType([PropTypes.bool.isRequired, PropTypes.oneOf(["and", "or"])]),
  loadingMessage: PropTypes.string,
  noOptionsMessage: PropTypes.string,
  searchThreshold: PropTypes.number,
  available: PropTypes.func,
  autoClose: PropTypes.bool,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle"]).isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired, PropTypes.shape({
    type: PropTypes.oneOf(["date"]).isRequired,
    raw: PropTypes.any.isRequired,
    granularity: PropTypes.oneOfType([PropTypes.shape({
      es: PropTypes.oneOf(["d", "w", "M", "y"]).isRequired,
      js: PropTypes.oneOf(["day", "week", "month", "year"]).isRequired,
      isSame: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      startOfNext: PropTypes.func.isRequired,
      iso8601: PropTypes.func.isRequired
    }).isRequired, PropTypes.oneOf([undefined])]).isRequired,
    text: PropTypes.string.isRequired,
    resolve: PropTypes.func.isRequired
  }).isRequired]).isRequired,
  name: PropTypes.string.isRequired,
  negatedName: PropTypes.string,
  available: PropTypes.func,
  operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
}).isRequired, PropTypes.shape({
  type: PropTypes.oneOf(["field_value_toggle_group"]).isRequired,
  field: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired, PropTypes.bool.isRequired]).isRequired,
    name: PropTypes.string.isRequired,
    negatedName: PropTypes.string,
    operator: PropTypes.oneOf(["eq", "exact", "gt", "gte", "lt", "lte"])
  }).isRequired).isRequired,
  available: PropTypes.func
}).isRequired];

try {
  DefaultItemActionProps.__docgenInfo = {
    description: '',
    displayName: 'DefaultItemActionProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: 'The type of action',
        name: 'type',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        required: false,
        type: {
          name: 'enum',
          raw: '"button" | "icon"',
          value: [{
            value: '"button"'
          }, {
            value: '"icon"'
          }]
        }
      },
      icon: {
        defaultValue: null,
        description: 'Associates an icon with the button',
        name: 'icon',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        required: false,
        type: {
          name: '"string" | "number" | "email" | "search" | "list" | "copy" | "link" | "menu" | "grid" | "filter" | "image" | "stop" | "accessibility" | "aggregate" | "alert" | "annotation" | "apps" | ... 388 more ... | IconFunction<...>'
        }
      },
      color: {
        defaultValue: null,
        description: 'Defines the color of the button',
        name: 'color',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemIconButtonAction'
        },
        required: false,
        type: {
          name: '"text" | "subdued" | "accent" | "danger" | "warning" | "ghost" | "primary" | "success" | EuiButtonIconColorFunction<T>'
        }
      },
      name: {
        defaultValue: null,
        description: 'The display name of the action (will be the button caption)',
        name: 'name',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: true,
        type: {
          name: 'string | number | boolean | {} | ReactElement<any, string | ((props: any) => ReactElement<any, string | ... | (new (props: any) => Component<any, any, any>)>) | (new (props: any) => Component<...>)> | ReactNodeArray | ReactPortal | ((item: T) => ReactNode)'
        }
      },
      description: {
        defaultValue: null,
        description: 'Describes the action (will be the button title)',
        name: 'description',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: true,
        type: {
          name: 'string'
        }
      },
      onClick: {
        defaultValue: null,
        description: 'A handler function to execute the action',
        name: 'onClick',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: '(item: T) => void'
        }
      },
      href: {
        defaultValue: null,
        description: '',
        name: 'href',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      target: {
        defaultValue: null,
        description: '',
        name: 'target',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is available',
        name: 'available',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      enabled: {
        defaultValue: null,
        description: 'A callback function that determines whether the action is enabled',
        name: 'enabled',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: '(item: T) => boolean'
        }
      },
      isPrimary: {
        defaultValue: null,
        description: '',
        name: 'isPrimary',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: 'boolean'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/basic_table/action_types.ts',
          name: 'DefaultItemActionBase'
        },
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType']
  };
} catch (e) {}

try {
  SearchProps.__docgenInfo = {
    description: '',
    displayName: 'SearchProps',
    methods: [],
    props: {
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: '(args: ArgsWithQuery | ArgsWithError) => boolean | void'
        }
      },
      defaultQuery: {
        defaultValue: null,
        description: 'The initial query the bar will hold when first mounted',
        name: 'defaultQuery',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      query: {
        defaultValue: null,
        description: 'If you wish to use the search bar as a controlled component, continuously pass the query via this prop.',
        name: 'query',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'QueryType'
        }
      },
      box: {
        defaultValue: null,
        description: 'Configures the search box. Set `placeholder` to change the placeholder text in the box and `incremental` to support incremental (as you type) search.',
        name: 'box',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'EuiFieldSearchProps & { schema?: boolean | SchemaType; }'
        }
      },
      filters: {
        defaultValue: null,
        description: 'An array of search filters. See #SearchFilterConfig.',
        name: 'filters',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'SearchFilterConfig[]'
        }
      },
      toolsLeft: {
        defaultValue: null,
        description: 'Tools which go to the left of the search bar.',
        name: 'toolsLeft',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'Tools'
        }
      },
      toolsRight: {
        defaultValue: null,
        description: 'Tools which go to the right of the search bar.',
        name: 'toolsRight',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'Tools'
        }
      },
      dateFormat: {
        defaultValue: null,
        description: 'Date formatter to use when parsing date values',
        name: 'dateFormat',
        parent: {
          fileName: 'app/src/components/search_bar/search_bar.tsx',
          name: 'EuiSearchBarProps'
        },
        required: false,
        type: {
          name: 'object'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'app/src/components/common.ts',
          name: 'CommonProps'
        },
        required: false,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType']
  };
} catch (e) {}

try {
  SearchFilterConfigProps.__docgenInfo = {
    description: '',
    displayName: 'SearchFilterConfigProps',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        required: true,
        type: {
          name: 'enum',
          raw: '"is" | "field_value_selection" | "field_value_toggle" | "field_value_toggle_group"',
          value: [{
            value: '"is"'
          }, {
            value: '"field_value_selection"'
          }, {
            value: '"field_value_toggle"'
          }, {
            value: '"field_value_toggle_group"'
          }]
        }
      },
      field: {
        defaultValue: null,
        description: '',
        name: 'field',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      name: {
        defaultValue: null,
        description: '',
        name: 'name',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        required: true,
        type: {
          name: 'string'
        }
      },
      negatedName: {
        defaultValue: null,
        description: '',
        name: 'negatedName',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      available: {
        defaultValue: null,
        description: '',
        name: 'available',
        parent: {
          fileName: 'app/src/components/search_bar/filters/is_filter.tsx',
          name: 'IsFilterConfigType'
        },
        required: false,
        type: {
          name: '(() => boolean) | (() => boolean) | (() => boolean) | (() => boolean)'
        }
      },
      options: {
        defaultValue: null,
        description: 'See #FieldValueOptionType',
        name: 'options',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: true,
        type: {
          name: 'FieldValueOptionType[] | OptionsLoader'
        }
      },
      filterWith: {
        defaultValue: null,
        description: '',
        name: 'filterWith',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: '"prefix" | "includes" | OptionsFilter'
        }
      },
      cache: {
        defaultValue: null,
        description: '',
        name: 'cache',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'number'
        }
      },
      multiSelect: {
        defaultValue: null,
        description: '',
        name: 'multiSelect',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'MultiSelect'
        }
      },
      loadingMessage: {
        defaultValue: null,
        description: '',
        name: 'loadingMessage',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      noOptionsMessage: {
        defaultValue: null,
        description: '',
        name: 'noOptionsMessage',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'string'
        }
      },
      searchThreshold: {
        defaultValue: null,
        description: '',
        name: 'searchThreshold',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'number'
        }
      },
      autoClose: {
        defaultValue: null,
        description: '',
        name: 'autoClose',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'boolean'
        }
      },
      operator: {
        defaultValue: null,
        description: '',
        name: 'operator',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_selection_filter.tsx',
          name: 'FieldValueSelectionFilterConfigType'
        },
        required: false,
        type: {
          name: 'enum',
          raw: 'OperatorType',
          value: [{
            value: '"eq"'
          }, {
            value: '"exact"'
          }, {
            value: '"gt"'
          }, {
            value: '"gte"'
          }, {
            value: '"lt"'
          }, {
            value: '"lte"'
          }]
        }
      },
      value: {
        defaultValue: null,
        description: '',
        name: 'value',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_filter.tsx',
          name: 'FieldValueToggleFilterConfigType'
        },
        required: true,
        type: {
          name: 'Value'
        }
      },
      items: {
        defaultValue: null,
        description: 'See #FieldValueToggleGroupFilterItemType',
        name: 'items',
        parent: {
          fileName: 'app/src/components/search_bar/filters/field_value_toggle_group_filter.tsx',
          name: 'FieldValueToggleGroupFilterConfigType'
        },
        required: true,
        type: {
          name: 'FieldValueToggleGroupFilterItemType[]'
        }
      }
    },
    extendedInterfaces: ['DefaultItemIconButtonAction', 'DefaultItemActionBase', 'Boolean', 'EuiSearchBarProps', 'CommonProps', 'IsFilterConfigType', 'FieldValueSelectionFilterConfigType', 'FieldValueToggleFilterConfigType', 'FieldValueToggleGroupFilterConfigType']
  };
} catch (e) {}